export default "__VITE_ASSET__CT3nWt7J__"